import { useIsNewSubway } from './hooks/useIsNewSubway';
import {
  StyledOldWizardWrapper,
  StyledWizardWrapper,
  StyledWizardWrapperInner,
  StyledOldWizardWrapperInner,
} from './styles';
import { WizardWrapperProps } from './types';

export const WizardWrapper = (props: WizardWrapperProps) => {
  const isNewSubway = useIsNewSubway();
  const WizardWrapperComponent = isNewSubway
    ? StyledWizardWrapper
    : StyledOldWizardWrapper;

  const WizardWrapperInnerComponent = isNewSubway
    ? StyledWizardWrapperInner
    : StyledOldWizardWrapperInner;

  return (
    <WizardWrapperComponent>
      <WizardWrapperInnerComponent
        container
        spacing={4}
        justifyContent="space-between"
        {...props}
      />
    </WizardWrapperComponent>
  );
};
